import svg4everybody from "svg4everybody";
import HandleToggle from "./classes/toggle";
import HandleSearch from "./classes/search";
import HandleReduWizardSlider from "./classes/reduwizard-slider";
import Tab from "./classes/tab";
import HandleYearRoundSlider from "./classes/yearround-slider";
import HandleSlider from "./classes/reduwizard-slider";
import ReduChart from "./classes/reduchart";
import HandleFormToggle from "./classes/form-toggle";
import Slider from "./classes/knowledge-slider";
import HandleAutoComplete from "./classes/autocomplete";
import Maps from "./classes/maps";
import CookiePopup from "./classes/cookiepopup";
import Video from "./classes/video";

/**
 *  App class
 *
 *  The App class functions a the main back-bone of the javascript used in this
 *  project.
 *
 */

class App {
  /**
   *  Constructor
   */
  constructor() {
    document.addEventListener(
      "DOMContentLoaded",
      function () {
        this.onDocumentReady();
      }.bind(this)
    );

    this.handleSearch();
    this.handleReduChart();
    this.handleTab();
    this.handleVideo();
    this.handleReduWizardSlider();
  }

  onDocumentReady() {
    svg4everybody();
    this.handleKnowledgeSlider();
    this.handleYearRoundSlider();
    this.handleAutoComplete();
    this.handleRadioToggle();
    this.handleErrors();
    this.handleCookiePopup();

    // Initialize toggle with debugging
    const toggleElements = document.querySelectorAll(".js--toggle");
    console.log('Found toggle elements:', toggleElements.length);
    
    if (toggleElements.length) {
      try {
        const toggle = new HandleToggle(toggleElements);
        console.log('Toggle initialized successfully');
        
        // Add touch event support for mobile
        toggleElements.forEach(element => {
          element.addEventListener('touchstart', (e) => {
            console.log('Touch event on toggle');
            e.preventDefault();
            const clickEvent = new MouseEvent('click', {
              view: window,
              bubbles: true,
              cancelable: true
            });
            element.dispatchEvent(clickEvent);
          }, { passive: false });
        });
      } catch (error) {
        console.error('Error initializing toggle:', error);
      }
    }
  }

  handleSearch() {
    const searchInputToggle = document.querySelector(".header-search");
    if (searchInputToggle) {
      new HandleSearch(searchInputToggle);
    }
  }

  handleVideo() {
    new Video();
  }

  handleTab() {
    const elem = document.querySelector(".js-tab-holder");
    if (elem !== null) {
      new Tab(elem);
    }
  }

  handleErrors() {
    const errorMessage = document.querySelector(".has-error");
    if (errorMessage) {
      errorMessage.addEventListener("click", () => {
        errorMessage.style.display = "none";
      });
    }
  }

  handleYearRoundSlider() {
    const yearRoundContainer = document.querySelector(".js--yearround-slider");
    if (yearRoundContainer) {
      new HandleYearRoundSlider(yearRoundContainer);
    }
  }

  handleReduWizardSlider() {
    const reduWizardContainer = document.querySelectorAll(
      ".js--reduwizard-slider"
    );
    if (reduWizardContainer.length > 0) {
      for (let index = 0; index < reduWizardContainer.length; index++) {
        const element = reduWizardContainer[index];
        const tabId = element.dataset.sliderTab;
        const slider = new HandleReduWizardSlider(element, tabId);
      }
    }
  }
  handleReduChart() {
    const reduChartWrapper = document.querySelector(".reduchart-container");
    if (reduChartWrapper) {
      new ReduChart();
    }
  }
  handleRadioToggle() {
    new HandleFormToggle();
  }

  handleAutoComplete() {
    const inputHolder = document.getElementById("step_three_location");
    if (inputHolder !== null) {
      new HandleAutoComplete();
    }
  }

  handleMaps(geos, defaultLatLng) {
    const mapContainer = document.querySelector(".map-container");
    if (mapContainer !== null) {
      new Maps(geos, defaultLatLng);
    }
  }

  handleKnowledgeSlider() {
    const sliderHolder = document.querySelector(".js-slider-holder");
    if (sliderHolder) {
      new Slider(sliderHolder);
    }
  }

  handleCookiePopup() {
    new CookiePopup();
  }
}

window.app = new App();
